import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-social-sidebar',
    templateUrl: './social-sidebar.component.html',
    styleUrls: ['./social-sidebar.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SocialSidebarComponent {

}
